import { useEffect, useState } from 'react';

import { obterAtivacaoDoAcompanhamento } from '../api/acessoAssociadoApi';
import { notify } from '../shared/feedback/notify';

/**
 * O interruptor do acompanhamento do associado (05/11/2026): decide se o botão "Compartilhar
 * Acompanhamento" aparece. Desligado, o servidor recusaria a ação — oferecer o botão seria
 * oferecer um erro.
 *
 * Falha ao consultar vale DESLIGADO (o mesmo lado seguro do servidor), mas não em silêncio: a tela
 * avisa que o botão pode estar faltando por erro, e não por decisão (regra da at-60).
 *
 * `consultar = false` (o TI, que nunca recebe o botão) não faz a chamada.
 */
export function useAcompanhamentoAtivo(consultar = true): boolean {
  const [ativo, setAtivo] = useState(false);

  useEffect(() => {
    if (!consultar) return;
    let vivo = true;
    obterAtivacaoDoAcompanhamento()
      .then((r) => {
        if (vivo) setAtivo(r.ativo === true);
      })
      .catch(() => {
        if (!vivo) return;
        setAtivo(false);
        notify.warning(
          'Não foi possível verificar se o acompanhamento do associado está ligado. O botão "Compartilhar Acompanhamento" fica oculto até recarregar a página.',
          { toastId: 'acompanhamento-ativacao' },
        );
      });
    return () => {
      vivo = false;
    };
  }, [consultar]);

  return ativo;
}
